import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UserService } from '../../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthAdminGuard  {
  constructor(private readonly userService: UserService,
    private readonly router: Router,
    private readonly msalGuard: MsalGuard) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const msalResult = await this.msalGuard.canActivate(route, state).toPromise();
    if (msalResult === true) {
      const user = await this.userService.currentUser.toPromise();
      if (!user.admin) {
        this.router.navigate(['/']);
      }
      return user.admin;
    }
    else {
      return msalResult;
    }
  }
  
}
